/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AptosCoinNewCoinListRequest = {
    type?: AptosCoinNewCoinListRequest.type;
    size?: number;
};

export namespace AptosCoinNewCoinListRequest {

    export enum type {
        ALL = 'ALL',
        MEME = 'MEME',
    }


}

